import { QuotationStatusEnum } from '@api/machines'

export enum Options {
  ADD_ATTACHMENT = 'add_attachment',
  ADD_CUSTOM_DEALER_FIT = 'add_custom_dealer_fit',
  ADD_DEALER_FIT = 'add_dealer_fit',
  ADD_DEALER_FIT_WITHIN_MACHINE = 'add_dealer_fit_within_machine',
  ADD_FACTORY_FIT = 'add_factory_fit',
  ADD_FACTORY_FIT_WITHIN_MACHINE = 'add_factory_fit_within_machine',
  ADD_SERVICE_CONTRACT = 'add_service_contract',
  ADD_TRANSPORT_OPTION = 'add_transport_option',
  ADD_TRANSPORT_OPTION_WITHIN_MACHINE = 'add_transport_option_within_machine',
  ADD_WARRANTY = 'add_warranty',
  ADD_WARRANTY_WITHIN_MACHINE = 'add_warranty_within_machine',
  REMOVE_ATTACHMENT = 'remove_attachment',
  REMOVE_DEALER_FIT = 'remove_dealer_fit',
  REMOVE_DEALER_FIT_WITHIN_MACHINE = 'remove_dealer_fit_within_machine',
  REMOVE_FACTORY_FIT = 'remove_factory_fit',
  REMOVE_FACTORY_FIT_WITHIN_MACHINE = 'remove_factory_fit_within_machine',
  REMOVE_SERVICE_CONTRACT = 'remove_service_contract',
  REMOVE_TRANSPORT_OPTION = 'remove_transport_option',
  REMOVE_TRANSPORT_OPTION_WITHIN_MACHINE = 'remove_transport_option_within_machine',
  REMOVE_WARRANTY = 'remove_warranty',
  REMOVE_WARRANTY_WITHIN_MACHINE = 'remove_warranty_within_machine',
  UPDATE_CUSTOM_DEALER_FIT = 'update_custom_dealer_fit'
}

export enum StockTypes {
  FACTORY_ORDER = 'Factory Order',
  IN_STOCK = 'In Stock - Unallocated',
  ON_ORDER = 'On order - Unallocated'
}

export enum QuoteType {
  ALL_QUOTES = 'all-quotes',
  MY_QUOTES = 'my-quotes'
}

export enum EqOptionType {
  FACTORY_FIT = 'Factory Fit',
  DEALER_FIT = 'Dealer Fit'
}

export enum ServicesTypes {
  WARRANTY = 'Warranty',
  SERVICE_CONTRACT = 'Service Contract',
  TRANSPORT = 'Transport'
}

export const SERVICE_CONTRACT_TYPES = {
  ARDUOUS: 'Arduous',
  NONE: 'None',
  STANDARD: 'Standard'
} as const

export enum QuoteStatus {
  ACCEPTED = 'Accepted',
  ARCHIVED = 'Archived',
  DRAFT = 'Draft',
  DRAFT_ACCEPTED_BY_CUSTOMER = 'DraftAcceptedByCustomer',
  DRAFT_ACCEPTED_ON_BEHALF_OF_CUSTOMER = 'DraftAcceptedOnBehalfOfCustomer',
  DRAFT_REJECTED_BY_CUSTOMER = 'DraftRejectedByCustomer',
  DRAFT_SENT_TO_CUSTOMER = 'DraftSentToCustomer',
  LEVEL_1_APPROVED_PENDING_LEVEL_2_APPROVAL = 'Level1ApprovedPendingLevel2Approval',
  NEEDS_REVISING = 'Needs_revising',
  PENDING_LEVEL_1_APPROVAL = 'PendingLevel1Approval',
  PENDING_LEVEL_2_APPROVAL = 'PendingLevel2Approval',
  PRICE_CHANGED = 'Price_changed',
  REJECTED_INTERNAL_L1 = 'Rejected_Internal_L1',
  REJECTED_INTERNAL_L2 = 'Rejected_Internal_L2'
}

const QuotationStatusMap: Record<QuoteStatus, QuotationStatusEnum> = {
  [QuoteStatus.DRAFT]: QuotationStatusEnum._0,
  [QuoteStatus.DRAFT_SENT_TO_CUSTOMER]: QuotationStatusEnum._1,
  [QuoteStatus.DRAFT_ACCEPTED_BY_CUSTOMER]: QuotationStatusEnum._2,
  [QuoteStatus.DRAFT_REJECTED_BY_CUSTOMER]: QuotationStatusEnum._3,
  [QuoteStatus.DRAFT_ACCEPTED_ON_BEHALF_OF_CUSTOMER]: QuotationStatusEnum._4,
  [QuoteStatus.PENDING_LEVEL_1_APPROVAL]: QuotationStatusEnum._5,
  [QuoteStatus.PENDING_LEVEL_2_APPROVAL]: QuotationStatusEnum._6,
  [QuoteStatus.LEVEL_1_APPROVED_PENDING_LEVEL_2_APPROVAL]:
    QuotationStatusEnum._7,
  [QuoteStatus.REJECTED_INTERNAL_L1]: QuotationStatusEnum._8,
  [QuoteStatus.REJECTED_INTERNAL_L2]: QuotationStatusEnum._9,
  [QuoteStatus.ACCEPTED]: QuotationStatusEnum._10,
  [QuoteStatus.PRICE_CHANGED]: QuotationStatusEnum._11,
  [QuoteStatus.NEEDS_REVISING]: QuotationStatusEnum._12,
  [QuoteStatus.ARCHIVED]: QuotationStatusEnum._90
}

export const QuotationStatusMapped = QuotationStatusMap

export enum QuotesSubTabs {
  ACCEPTED = 'Accepted',
  CUSTOMER_APPROVALS = 'Customer Approvals',
  DRAFTS = 'Drafts',
  INTERNAL_APPROVALS = 'Internal Approvals',
  ARCHIVED = 'Archived'
}

export enum RuleStatusAsPerApiResponse {
  ACTIVE = 'Active',
  REVIEW_NEEDED = 'Review Needed'
}

export enum RuleStatusEquivalent {
  ACTIVE = 'Active',
  REVIEW_NEEDED = 'In Error'
}

export enum QuoteItemStockStatus {
  SOLD = 'Sold',
  IN_STOCK = 'Stock',
  ON_ORDER = 'On order',
  ON_ORDER_BLOCKED = 'On order - blocked',
  ON_ORDER_UNALLOCATED = 'On order - Unallocated',
  BLOCKED = 'Blocked',
  IN_STOCK_UNALLOCATED = 'In Stock - Unallocated',
  IN_STOCK_BLOCKED = 'In Stock - Blocked',
  CUSTOMER_OWNED = 'Customer owned',
  SOLD_PENDING_DELIVERY = 'Sold pending delivery'
}

export enum CustomersTabs {
  Overview = 'overview',
  Delivery = 'delivery',
  Quotes = 'quotes',
  Specs = 'specs'
}

export enum ArchiveRestoreDialogVariant {
  Archive = 'Archive',
  Restore = 'Restore'
}

export enum ResponseStatusCodes {
  Forbidden = 403,
  ExpectationFailed = 417,
  Conflict = 409
}

export enum CustomerMergingStatus {
  ManualRecordCustomer = 0,
  MasterRecordCustomer = 1,
  MergeInProgress = 2
}

export enum ApprovalRuleStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum WizardErrorSteps {
  NO_ERROR = -1,
  OPTIONS = 0,
  OVERVIEW = 2,
  SERVICES = 1
}

export enum QuoteActions {
  ARCHIVE = 'archive',
  RESTORE = 'restore',
  DELETE = 'delete'
}
